// Prompt 2 UI keys — intelligence & personalization (recipe scaling, supermarket
// mode, decoration budget tool, table recreation, gift plans, budget page).
export const extra3 = {
  pt: {
    "recipe.portions": "Porções",
    "recipe.for_guests": "Ajustar para convidados",
    "recipe.scaled_hint": "Quantidades estimadas para {n} pessoas (fator ×{f}).",
    "recipe.base": "Receita base: {n} porções",
    "shopping.market_mode": "Modo Supermercado",
    "shopping.list_mode": "Modo Lista",
    "shopping.market_hint": "Toque para marcar o que já colocou no carrinho.",
    "shopping.all_done": "Tudo no carrinho! 🛒",
    "shopping.consolidated": "Itens repetidos foram unificados.",
    "deco.budget_tool": "Orçamento de Decoração",
    "deco.budget_tool_sub": "Distribua seu orçamento por categoria. Valores estimados.",
    "deco.set_total": "Orçamento total",
    "deco.distributed": "Distribuído",
    "deco.remaining": "Disponível",
    "deco.over": "Você ultrapassou o orçamento em {v}",
    "deco.save_budget": "Salvar no Meu Orçamento",
    "deco.saved": "Decoração salva no seu orçamento!",
    "deco.saves_title": "Meus salvamentos", "table.cost_title": "Custo estimado no seu país (Google Shopping)", "table.cost_note": "Produtos escolhidos para caber no orçamento da Mesa, com preços reais do mercado {m}.", "table.cost_over": "A mesa estimada ({s}) passa {v} do orçamento ({b}).", "saves.rename": "Renomear", "deco.discard_plan": "Excluir sem salvar", "saves.save_changes": "Salvar alterações", "saves.discard": "Descartar", "saves.unsaved": "Você tem alterações não salvas.", "saves.load": "Carregar no plano para continuar", "saves.loaded": "Salvamento carregado! Continue montando e salve uma nova versão.", "saves.over_total": "Este salvamento ({s}) está {v} acima do orçamento atual ({b}). Edite ou exclua itens para ajustar.", "saves.find_product": "Buscar produto", "saves.swap_item": "Buscar outros e substituir", "saves.name_ph": "Nome desta versão", "saves.over_budget": "Este salvamento ({s}) está {v} acima do orçamento atual ({b}). Edite as quantidades ou exclua itens para ajustar.", "saves.remove_item": "Excluir item", "saves.updated": "Salvamento atualizado!",
    "deco.saves_hint": "Você pode guardar até 3 versões. Clique para ver os itens.",
    "deco.saves_empty": "Nenhum salvamento ainda.",
    "deco.saved_items": "Itens salvos",
    "deco.saves_full": "Limite de 3 salvamentos atingido. Exclua um para salvar outro.",
    "deco.reset_alloc": "Redistribuir automaticamente",
    "deco.tree_guide_title": "Montagem da árvore passo a passo",
    "deco.auto_hint": "Distribuímos automaticamente com base em um Natal equilibrado. Ajuste como quiser.",
    "table.recreate": "Recriar esta mesa",
    "table.hide_items": "Ocultar itens",
    "table.items_title": "Itens para montar",
    "table.add_all": "Adicionar tudo à lista",
    "table.items_added": "Itens adicionados à lista de compras!",
    "gifts.my_plan": "Meu plano de presentes",
    "gifts.plan_this": "Adicionar ao plano",
    "gifts.recipient_ph": "Para quem é este presente?",
    "gifts.status.choose": "Escolher",
    "gifts.status.buy": "Comprar",
    "gifts.status.wrap": "Embrulhar",
    "gifts.planned": "Valor estimado",
    "gifts.plan_empty": "Você ainda não adicionou presentes ao seu plano.",
    "gifts.plan_total": "Total estimado",
    "gifts.added_plan": "Presente adicionado ao plano!", "gifts.saved_item": "Presente salvo em Meus salvamentos!",
    "gifts.remove": "Remover",
    "gifts.add_manual": "Adicionar presente",
    "budget.subtitle": "Acompanhe o quanto planeja gastar no Natal. Valores são estimativas.",
    "budget.gifts_auto": "Somado automaticamente do seu plano de presentes.",
    "dash.view_budget": "Ver meu orçamento",
  },
  en: {
    "recipe.portions": "Servings",
    "recipe.for_guests": "Adjust for guests",
    "recipe.scaled_hint": "Estimated quantities for {n} people (factor ×{f}).",
    "recipe.base": "Base recipe: {n} servings",
    "shopping.market_mode": "Supermarket Mode",
    "shopping.list_mode": "List Mode",
    "shopping.market_hint": "Tap to check off what's already in your cart.",
    "shopping.all_done": "All in the cart! 🛒",
    "shopping.consolidated": "Duplicate items were merged.",
    "deco.budget_tool": "Decoration Budget",
    "deco.budget_tool_sub": "Split your budget across categories. Estimated values.",
    "deco.set_total": "Total budget",
    "deco.distributed": "Distributed",
    "deco.remaining": "Available",
    "deco.over": "You're over budget by {v}",
    "deco.save_budget": "Save to My Budget",
    "deco.saved": "Decoration saved to your budget!",
    "deco.saves_title": "My saves", "table.cost_title": "Estimated cost in your country (Google Shopping)", "table.cost_note": "Products picked to fit the Table budget, with real prices from the {m} market.", "table.cost_over": "The estimated table ({s}) is {v} over budget ({b}).", "saves.rename": "Rename", "deco.discard_plan": "Discard without saving", "saves.save_changes": "Save changes", "saves.discard": "Discard", "saves.unsaved": "You have unsaved changes.", "saves.load": "Load into plan to continue", "saves.loaded": "Save loaded! Keep building and save a new version.", "saves.over_total": "This save ({s}) is {v} above your current budget ({b}). Edit or remove items to adjust.", "saves.find_product": "Find product", "saves.swap_item": "Find others and replace", "saves.name_ph": "Name this version", "saves.over_budget": "This save ({s}) is {v} above your current budget ({b}). Edit quantities or remove items to adjust.", "saves.remove_item": "Remove item", "saves.updated": "Save updated!",
    "deco.saves_hint": "You can keep up to 3 versions. Click to see the items.",
    "deco.saves_empty": "No saves yet.",
    "deco.saved_items": "Saved items",
    "deco.saves_full": "You reached the limit of 3 saves. Delete one to save another.",
    "deco.reset_alloc": "Auto-distribute again",
    "deco.tree_guide_title": "Step-by-step tree assembly",
    "deco.auto_hint": "We split it automatically for a balanced Christmas. Adjust as you like.",
    "table.recreate": "Recreate this table",
    "table.hide_items": "Hide items",
    "table.items_title": "Items to set it up",
    "table.add_all": "Add all to list",
    "table.items_added": "Items added to your shopping list!",
    "gifts.my_plan": "My gift plan",
    "gifts.plan_this": "Add to plan",
    "gifts.recipient_ph": "Who is this gift for?",
    "gifts.status.choose": "Choose",
    "gifts.status.buy": "Buy",
    "gifts.status.wrap": "Wrap",
    "gifts.planned": "Estimated cost",
    "gifts.plan_empty": "You haven't added any gifts to your plan yet.",
    "gifts.plan_total": "Estimated total",
    "gifts.added_plan": "Gift added to your plan!", "gifts.saved_item": "Gift saved to My saves!",
    "gifts.remove": "Remove",
    "gifts.add_manual": "Add gift",
    "budget.subtitle": "Track how much you plan to spend this Christmas. Values are estimates.",
    "budget.gifts_auto": "Automatically summed from your gift plan.",
    "dash.view_budget": "View my budget",
  },
  es: {
    "recipe.portions": "Porciones",
    "recipe.for_guests": "Ajustar para invitados",
    "recipe.scaled_hint": "Cantidades estimadas para {n} personas (factor ×{f}).",
    "recipe.base": "Receta base: {n} porciones",
    "shopping.market_mode": "Modo Supermercado",
    "shopping.list_mode": "Modo Lista",
    "shopping.market_hint": "Toca para marcar lo que ya está en el carrito.",
    "shopping.all_done": "¡Todo en el carrito! 🛒",
    "shopping.consolidated": "Se unificaron los ítems repetidos.",
    "deco.budget_tool": "Presupuesto de Decoración",
    "deco.budget_tool_sub": "Reparte tu presupuesto por categoría. Valores estimados.",
    "deco.set_total": "Presupuesto total",
    "deco.distributed": "Distribuido",
    "deco.remaining": "Disponible",
    "deco.over": "Superaste el presupuesto en {v}",
    "deco.save_budget": "Guardar en Mi Presupuesto",
    "deco.saved": "¡Decoración guardada en tu presupuesto!",
    "deco.saves_title": "Mis guardados", "table.cost_title": "Costo estimado en tu país (Google Shopping)", "table.cost_note": "Productos elegidos para caber en el presupuesto de la Mesa, con precios reales del mercado {m}.", "table.cost_over": "La mesa estimada ({s}) supera en {v} el presupuesto ({b}).", "saves.rename": "Renombrar", "deco.discard_plan": "Eliminar sin guardar", "saves.save_changes": "Guardar cambios", "saves.discard": "Descartar", "saves.unsaved": "Tienes cambios sin guardar.", "saves.load": "Cargar en el plan para continuar", "saves.loaded": "¡Guardado cargado! Sigue montando y guarda una nueva versión.", "saves.over_total": "Este guardado ({s}) supera en {v} tu presupuesto actual ({b}). Edita o elimina artículos.", "saves.find_product": "Buscar producto", "saves.swap_item": "Buscar otros y reemplazar", "saves.name_ph": "Nombre de esta versión", "saves.over_budget": "Este guardado ({s}) supera en {v} tu presupuesto actual ({b}). Edita cantidades o elimina artículos para ajustar.", "saves.remove_item": "Eliminar artículo", "saves.updated": "¡Guardado actualizado!",
    "deco.saves_hint": "Puedes guardar hasta 3 versiones. Haz clic para ver los artículos.",
    "deco.saves_empty": "Aún no hay guardados.",
    "deco.saved_items": "Artículos guardados",
    "deco.saves_full": "Alcanzaste el límite de 3 guardados. Elimina uno para guardar otro.",
    "deco.reset_alloc": "Redistribuir automáticamente",
    "deco.tree_guide_title": "Montaje del árbol paso a paso",
    "deco.auto_hint": "Lo repartimos automáticamente para una Navidad equilibrada. Ajusta a tu gusto.",
    "table.recreate": "Recrear esta mesa",
    "table.hide_items": "Ocultar ítems",
    "table.items_title": "Ítems para montarla",
    "table.add_all": "Añadir todo a la lista",
    "table.items_added": "¡Ítems añadidos a tu lista de compras!",
    "gifts.my_plan": "Mi plan de regalos",
    "gifts.plan_this": "Añadir al plan",
    "gifts.recipient_ph": "¿Para quién es este regalo?",
    "gifts.status.choose": "Elegir",
    "gifts.status.buy": "Comprar",
    "gifts.status.wrap": "Envolver",
    "gifts.planned": "Coste estimado",
    "gifts.plan_empty": "Aún no has añadido regalos a tu plan.",
    "gifts.plan_total": "Total estimado",
    "gifts.added_plan": "¡Regalo añadido a tu plan!", "gifts.saved_item": "¡Regalo guardado en Mis guardados!",
    "gifts.remove": "Quitar",
    "gifts.add_manual": "Añadir regalo",
    "budget.subtitle": "Controla cuánto piensas gastar esta Navidad. Los valores son estimaciones.",
    "budget.gifts_auto": "Sumado automáticamente de tu plan de regalos.",
    "dash.view_budget": "Ver mi presupuesto",
  },
  fr: {
    "recipe.portions": "Portions",
    "recipe.for_guests": "Ajuster aux invités",
    "recipe.scaled_hint": "Quantités estimées pour {n} personnes (facteur ×{f}).",
    "recipe.base": "Recette de base : {n} portions",
    "shopping.market_mode": "Mode Supermarché",
    "shopping.list_mode": "Mode Liste",
    "shopping.market_hint": "Touchez pour cocher ce qui est déjà dans le panier.",
    "shopping.all_done": "Tout est dans le panier ! 🛒",
    "shopping.consolidated": "Les articles en double ont été fusionnés.",
    "deco.budget_tool": "Budget Décoration",
    "deco.budget_tool_sub": "Répartissez votre budget par catégorie. Valeurs estimées.",
    "deco.set_total": "Budget total",
    "deco.distributed": "Réparti",
    "deco.remaining": "Disponible",
    "deco.over": "Vous dépassez le budget de {v}",
    "deco.save_budget": "Enregistrer dans Mon Budget",
    "deco.saved": "Décoration enregistrée dans votre budget !",
    "deco.saves_title": "Mes enregistrements", "table.cost_title": "Coût estimé dans votre pays (Google Shopping)", "table.cost_note": "Produits choisis pour respecter le budget Table, aux prix réels du marché {m}.", "table.cost_over": "La table estimée ({s}) dépasse le budget ({b}) de {v}.", "saves.rename": "Renommer", "deco.discard_plan": "Supprimer sans enregistrer", "saves.save_changes": "Enregistrer les modifications", "saves.discard": "Annuler", "saves.unsaved": "Vous avez des modifications non enregistrées.", "saves.load": "Charger dans le plan pour continuer", "saves.loaded": "Enregistrement chargé ! Continuez et enregistrez une nouvelle version.", "saves.over_total": "Cet enregistrement ({s}) dépasse de {v} votre budget actuel ({b}). Modifiez ou supprimez des articles.", "saves.find_product": "Trouver le produit", "saves.swap_item": "Chercher d’autres et remplacer", "saves.name_ph": "Nom de cette version", "saves.over_budget": "Cet enregistrement ({s}) dépasse de {v} votre budget actuel ({b}). Modifiez les quantités ou supprimez des articles.", "saves.remove_item": "Supprimer l'article", "saves.updated": "Enregistrement mis à jour !",
    "deco.saves_hint": "Vous pouvez conserver jusqu'à 3 versions. Cliquez pour voir les articles.",
    "deco.saves_empty": "Aucun enregistrement pour le moment.",
    "deco.saved_items": "Articles enregistrés",
    "deco.saves_full": "Limite de 3 enregistrements atteinte. Supprimez-en un pour en enregistrer un autre.",
    "deco.reset_alloc": "Redistribuer automatiquement",
    "deco.tree_guide_title": "Montage du sapin étape par étape",
    "deco.auto_hint": "Nous répartissons automatiquement pour un Noël équilibré. Ajustez à votre guise.",
    "table.recreate": "Recréer cette table",
    "table.hide_items": "Masquer les articles",
    "table.items_title": "Articles pour la dresser",
    "table.add_all": "Tout ajouter à la liste",
    "table.items_added": "Articles ajoutés à votre liste de courses !",
    "gifts.my_plan": "Mon plan de cadeaux",
    "gifts.plan_this": "Ajouter au plan",
    "gifts.recipient_ph": "Pour qui est ce cadeau ?",
    "gifts.status.choose": "Choisir",
    "gifts.status.buy": "Acheter",
    "gifts.status.wrap": "Emballer",
    "gifts.planned": "Coût estimé",
    "gifts.plan_empty": "Vous n'avez pas encore ajouté de cadeaux à votre plan.",
    "gifts.plan_total": "Total estimé",
    "gifts.added_plan": "Cadeau ajouté à votre plan !", "gifts.saved_item": "Cadeau enregistré dans Mes enregistrements !",
    "gifts.remove": "Retirer",
    "gifts.add_manual": "Ajouter un cadeau",
    "budget.subtitle": "Suivez ce que vous prévoyez de dépenser ce Noël. Les valeurs sont des estimations.",
    "budget.gifts_auto": "Additionné automatiquement depuis votre plan de cadeaux.",
    "dash.view_budget": "Voir mon budget",
  },
  it: {
    "recipe.portions": "Porzioni",
    "recipe.for_guests": "Adatta agli ospiti",
    "recipe.scaled_hint": "Quantità stimate per {n} persone (fattore ×{f}).",
    "recipe.base": "Ricetta base: {n} porzioni",
    "shopping.market_mode": "Modalità Supermercato",
    "shopping.list_mode": "Modalità Lista",
    "shopping.market_hint": "Tocca per segnare ciò che è già nel carrello.",
    "shopping.all_done": "Tutto nel carrello! 🛒",
    "shopping.consolidated": "Gli articoli ripetuti sono stati uniti.",
    "deco.budget_tool": "Budget Decorazione",
    "deco.budget_tool_sub": "Distribuisci il budget per categoria. Valori stimati.",
    "deco.set_total": "Budget totale",
    "deco.distributed": "Distribuito",
    "deco.remaining": "Disponibile",
    "deco.over": "Hai superato il budget di {v}",
    "deco.save_budget": "Salva nel Mio Budget",
    "deco.saved": "Decorazione salvata nel tuo budget!",
    "deco.saves_title": "I miei salvataggi", "table.cost_title": "Costo stimato nel tuo paese (Google Shopping)", "table.cost_note": "Prodotti scelti per rientrare nel budget Tavola, con prezzi reali del mercato {m}.", "table.cost_over": "La tavola stimata ({s}) supera di {v} il budget ({b}).", "saves.rename": "Rinomina", "deco.discard_plan": "Elimina senza salvare", "saves.save_changes": "Salva modifiche", "saves.discard": "Annulla", "saves.unsaved": "Hai modifiche non salvate.", "saves.load": "Carica nel piano per continuare", "saves.loaded": "Salvataggio caricato! Continua e salva una nuova versione.", "saves.over_total": "Questo salvataggio ({s}) supera di {v} il budget attuale ({b}). Modifica o elimina articoli.", "saves.find_product": "Cerca prodotto", "saves.swap_item": "Cerca altri e sostituisci", "saves.name_ph": "Nome di questa versione", "saves.over_budget": "Questo salvataggio ({s}) supera di {v} il budget attuale ({b}). Modifica le quantità o elimina articoli.", "saves.remove_item": "Elimina articolo", "saves.updated": "Salvataggio aggiornato!",
    "deco.saves_hint": "Puoi conservare fino a 3 versioni. Clicca per vedere gli articoli.",
    "deco.saves_empty": "Ancora nessun salvataggio.",
    "deco.saved_items": "Articoli salvati",
    "deco.saves_full": "Hai raggiunto il limite di 3 salvataggi. Eliminane uno per salvarne un altro.",
    "deco.reset_alloc": "Ridistribuisci automaticamente",
    "deco.tree_guide_title": "Montaggio dell'albero passo dopo passo",
    "deco.auto_hint": "Distribuiamo automaticamente per un Natale equilibrato. Regola come preferisci.",
    "table.recreate": "Ricrea questa tavola",
    "table.hide_items": "Nascondi articoli",
    "table.items_title": "Articoli per allestirla",
    "table.add_all": "Aggiungi tutto alla lista",
    "table.items_added": "Articoli aggiunti alla tua lista della spesa!",
    "gifts.my_plan": "Il mio piano regali",
    "gifts.plan_this": "Aggiungi al piano",
    "gifts.recipient_ph": "Per chi è questo regalo?",
    "gifts.status.choose": "Scegliere",
    "gifts.status.buy": "Comprare",
    "gifts.status.wrap": "Incartare",
    "gifts.planned": "Costo stimato",
    "gifts.plan_empty": "Non hai ancora aggiunto regali al tuo piano.",
    "gifts.plan_total": "Totale stimato",
    "gifts.added_plan": "Regalo aggiunto al piano!", "gifts.saved_item": "Regalo salvato in I miei salvataggi!",
    "gifts.remove": "Rimuovi",
    "gifts.add_manual": "Aggiungi regalo",
    "budget.subtitle": "Tieni traccia di quanto pensi di spendere questo Natale. I valori sono stime.",
    "budget.gifts_auto": "Sommato automaticamente dal tuo piano regali.",
    "dash.view_budget": "Vedi il mio budget",
  },
};
